import React from "react";
import { PhoneCall, ClipboardCheck, Wrench, Sparkles } from "lucide-react";
import { Progress } from "@/components/ui/progress";
const steps = [{
  id: 1,
  title: "Ανάλυση & Έλεγχος",
  desc: "Πραγματοποιούμε ενδελεχή έλεγχο των υφιστάμενων υποδομών σας για τον εντοπισμό κενών ασφαλείας και αναγκών.",
  icon: ClipboardCheck
}, {
  id: 2,
  title: "Αρχιτεκτονική Λύσης",
  desc: "Σχεδιάζουμε εξατομικευμένα συστήματα δικτύου και ασφάλειας που ανταποκρίνονται στις δικές σας απαιτήσεις.",
  icon: PhoneCall
}, {
  id: 3,
  title: "Εγκατάσταση & Ρύθμιση",
  desc: "Υλοποιούμε τις λύσεις με κορυφαίο εξοπλισμό, από servers μέχρι προηγμένα συστήματα access control.",
  icon: Wrench
}, {
  id: 4,
  title: "Συνεχής Υποστήριξη",
  desc: "Παρέχουμε 24/7 παρακολούθηση και τεχνική υποστήριξη για την απρόσκοπτη λειτουργία της επιχείρησής σας.",
  icon: Sparkles
}];
export default function WorkProcess() {
  return <section data-section-id="123417" id="η-διαδικασία-θωράκισης" className="dark bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-background to-background pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4 tracking-tighter uppercase">Η Διαδικασια Θωρακισης</h2>
          <p className="text-slate-400 text-lg font-medium">
            Μια δομημένη προσέγγιση τεσσάρων σταδίων για την απόλυτη ψηφιακή και 
            φυσική ασφάλεια του επαγγελματικού σας χώρου.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          {}
          <div className="hidden md:block absolute top-8 left-[12.5%] right-[12.5%] -translate-y-1/2 z-0">
            <Progress value={0} className="h-[2px] bg-white/10" />
          </div>

          {}
          <div className="md:hidden absolute top-8 bottom-8 left-8 w-[2px] bg-white/10 -translate-x-1/2 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6">
            {steps.map((step, i) => <div key={step.id} data-index={i} className="relative z-10 flex md:flex-col items-start md:items-center gap-6 md:gap-6 group">
                {}
                <div className="shrink-0 w-16 h-16 rounded-full bg-slate-900/80 backdrop-blur-xl border-2 border-primary/30 shadow-[0_0_20px_rgba(6,182,212,0.15)] flex items-center justify-center text-2xl font-mono font-bold text-primary relative transition-all duration-300 group-hover:scale-110 group-hover:border-primary group-hover:shadow-[0_0_25px_rgba(6,182,212,0.4)]">
                  {step.id}
                </div>

                {}
                <div className="flex-1 md:text-center pt-1 md:pt-0">
                  <div className="flex items-center md:justify-center gap-2 mb-3">
                    <step.icon className="w-5 h-5 text-primary" />
                    <h3 className="text-xl font-bold text-foreground tracking-tight">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-slate-400 text-sm leading-relaxed font-normal">
                    {step.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}